import classNames from 'classnames';
import { GetPageComponentViewModel } from '@/types/cml-api';
import { NavigationCarousel } from '@/features/carousel';
import { CarouselOptions } from '@/features/carousel/types';
import CarouselIconItem from './carousel-icon-item';
import Skeleton from './skeleton';
import { deviceTypeClassGenerator } from '../../_utils/device-type-handlers';
import { IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps {
  data: GetPageComponentViewModel;
}
export function CarouselIcon({
  data,
  isLazy
}: Props) {
  const options: CarouselOptions = {
    mode: 'snap',
    perView: 'auto',
    breakPoints: {
      desktop: {
        perView: 6,
        spacing: 2
      },
      mobile: {
        perView: 4.3,
        spacing: 4
      }
    }
  };
  const carouselItems = data.items?.map((item, index) => <CarouselIconItem key={item.id || item.link} {...item} index={index} isLazy={isLazy || index >= 6} sortKey={data?.sortKey} componentId={data?.id} />);
  return <div className={classNames('homepage-container my-2 !pl-0', deviceTypeClassGenerator(data.deviceTypes || ''))} data-sentry-component="CarouselIcon" data-sentry-source-file="carousel-icon.tsx">
            <div className='relative min-h-[70px] pl-2 lg:min-h-[100px] lg:px-20'>
                <NavigationCarousel options={options} skeleton={<Skeleton />} data-sentry-element="NavigationCarousel" data-sentry-source-file="carousel-icon.tsx">
                    {carouselItems}
                </NavigationCarousel>
            </div>
        </div>;
}